/**
 * utils/formatUtils.js
 * Date, number, timestamp formatting helpers
 */

export const formatNumber = (n) =>
  typeof n === "number" ? n.toLocaleString() : n || "—";

export const formatDate = () =>
  new Date().toLocaleString("en-US", {
    year:"numeric", month:"long", day:"numeric",
    hour:"2-digit", minute:"2-digit", timeZoneName:"short"
  });

export const parseTimestamp = (val) => {
  if (!val && val !== 0) return null;
  const s = String(val).trim();
  if (/^\d+(\.\d+)?$/.test(s)) {
    const n = parseFloat(s);
    if (n > 946684800    && n < 4102444800)    return new Date(n * 1000);
    if (n > 946684800000 && n < 4102444800000) return new Date(n);
    if (n > 946684800000000)                   return new Date(n / 1000);
    return null;
  }
  try {
    const d = new Date(s);
    if (!isNaN(d) && d.getFullYear() > 1990 && d.getFullYear() < 2100) return d;
  } catch {}
  return null;
};

export const estimateMTTD = (totalEvents, anomalyRate) => {
  const baseMinutes    = 194 * 24 * 60;
  const mlReduction    = Math.min((anomalyRate || 0) / 100, 0.95);
  const estimatedMinutes = Math.round(baseMinutes * (1 - mlReduction) * 0.01);
  if (estimatedMinutes < 60)   return `${estimatedMinutes} minutes`;
  if (estimatedMinutes < 1440) return `${Math.round(estimatedMinutes / 60)} hours`;
  return `${Math.round(estimatedMinutes / 1440)} days`;
};

export const calculateAlertFatigue = (total, critical, high) => {
  if (!total) return 0;
  const actionable = critical + high;
  const noise      = total - actionable;
  return Math.round((noise / total) * 100);
};
